import styled from "styled-components";
import KmamkLogo from "../../assets/kmamk_SR.png";
import OkuniSchoolLogo from "../../assets/okuni_school_lime (1).png";
import { NavLink } from "react-router-dom";

import theme from "../../styles/theme";
import Links from "./Links";
import DonateLink from "./DonateLink";

const irBlueColor = "#1f3c85";

const HeaderTopContainer = styled.div`
  background-color: ${irBlueColor};
  @media (max-width: ${theme.breakpointsCustom.mobile}px) {
    display: none;
  }
`;

const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 36px;
  max-width: ${theme.breakpointsCustom.max}px;
  margin: auto;
  padding: 4px 5px 4px 10px;
`;

const StyledLinkBottom = styled(NavLink)`
  text-decoration: none;
  color: ${theme.colors.white};
  font-size: 14px;
   font-weight: 500;
  font-family: "Montserrat", sans-serif;sans-serif;
  transition: all 0.2s;
  &.active {
    color: ${theme.colors.green};
    font-weight: 500;
  }
`;

const HeaderTopLinks = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  gap: 15px;
`;

const LinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  gap: 15px;
  padding-right: 15px;
`;
const HeaderTopNavigation = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  gap: 15px;
`;

const PartnersLink = styled.a`
  padding: 0;
  margin: 0;
  height: 24px;
`;

const StledImg = styled.img`
  height: 24px;
`;

const Partners = styled.div`
  display: flex;
  gap: 24px;
  margin-right: 120px;
`;

const TopHeader = () => {
  return (
    <HeaderTopContainer>
      <HeaderTop>
        <HeaderTopLinks>
          <Links color={theme.colors.white} />
          <DonateLink />
        </HeaderTopLinks>
        <HeaderTopNavigation>
          <LinkContainer>
            <Partners>
              <PartnersLink href="https://discord.com/invite/dhdn9xqhj6" target="blank">
                <StledImg src={KmamkLogo} />
              </PartnersLink>
              <PartnersLink href="https://discord.gg/FpG4snUZp2" target="blank">
                <StledImg src={OkuniSchoolLogo} />
              </PartnersLink>
            </Partners>
            <StyledLinkBottom to="/about-us">Про Нас</StyledLinkBottom>
            <StyledLinkBottom to="/faq">Регламент</StyledLinkBottom>
          </LinkContainer>
        </HeaderTopNavigation>
      </HeaderTop>
    </HeaderTopContainer>
  );
};

export default TopHeader;
